const PHONE = '03-3261-9551';
const FAX   = '050-6865-3317';
const EMAIL = 'info@s-a-security.com';
const LOGO = 'https://static.readdy.ai/image/3b449c48e525fa5b7f514f383582948f/a6aa99d086618289a416ba1d8c9e0dad.png';

const footerLinks = [
  { label: 'サービスの強み', id: 'strengths' },
  { label: '対応業務', id: 'services' },
  { label: '対応エリア', id: 'area' },
  { label: '会社概要', id: 'company' },
  { label: 'お問い合わせ', id: 'contact' },
  { label: '採用情報', id: 'recruitment' },
];

export default function Footer() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer>
      <div className="bg-[#0D1A4E] py-12">
        <div className="max-w-6xl mx-auto px-6 flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="text-center md:text-left">
            <p className="text-white font-black text-xl">まずはお気軽にご連絡ください</p>
            <p className="text-white/70 text-sm mt-1">電話・メール・FAX、どの方法でも承ります</p>
          </div>
          <a
            href={`tel:${PHONE}`}
            className="bg-[#38BDF8] hover:bg-[#7dd3fc] text-[#0D1A4E] px-10 py-4 rounded-md font-black whitespace-nowrap transition-colors flex items-center gap-3 cursor-pointer text-xl"
          >
            <div className="w-6 h-6 flex items-center justify-center">
              <i className="ri-phone-fill text-2xl"></i>
            </div>
            {PHONE}
          </a>
        </div>
      </div>

      <div className="bg-[#080f2e] pt-14 pb-8">
        <div className="max-w-6xl mx-auto px-6">
          <div className="grid md:grid-cols-3 gap-10 mb-10">
            <div>
              <img src={LOGO} alt="株式会社S.A.Securityロゴ" className="h-10 w-auto object-contain mb-4" />
              <p className="text-white/60 text-xs leading-relaxed">
                設立2年、急成長中。<br />
                品質とスピードへの徹底したこだわりで、<br />
                地域の現場安全を支え続けます。
              </p>
            </div>

            <div>
              <p className="text-white font-bold text-sm mb-4">サイトマップ</p>
              <ul className="space-y-2">
                {footerLinks.map((link) => (
                  <li key={link.id}>
                    <button
                      onClick={() => scrollTo(link.id)}
                      className="text-white/60 hover:text-[#38BDF8] text-sm transition-colors cursor-pointer whitespace-nowrap"
                    >
                      <i className="ri-arrow-right-s-line mr-1 text-xs"></i>
                      {link.label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <p className="text-white font-bold text-sm mb-4">お問い合わせ</p>
              <div className="space-y-3">
                <div className="flex items-start gap-3">
                  <div className="w-4 h-4 flex items-center justify-center mt-0.5 flex-shrink-0">
                    <i className="ri-phone-line text-[#38BDF8] text-sm"></i>
                  </div>
                  <div>
                    <p className="text-white text-sm font-bold">{PHONE}</p>
                    <p className="text-white/50 text-xs">平日 8:00〜18:00</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-4 h-4 flex items-center justify-center mt-0.5 flex-shrink-0">
                    <i className="ri-printer-line text-[#38BDF8] text-sm"></i>
                  </div>
                  <div>
                    <p className="text-white text-sm font-bold">{FAX}</p>
                    <p className="text-white/50 text-xs">FAX（24時間受付）</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-4 h-4 flex items-center justify-center mt-0.5 flex-shrink-0">
                    <i className="ri-mail-line text-[#38BDF8] text-sm"></i>
                  </div>
                  <div>
                    <p className="text-white text-sm font-bold break-all">{EMAIL}</p>
                    <p className="text-white/50 text-xs">メール（24時間受付）</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-4 h-4 flex items-center justify-center mt-0.5 flex-shrink-0">
                    <i className="ri-map-pin-line text-[#38BDF8] text-sm"></i>
                  </div>
                  <p className="text-white/60 text-xs leading-relaxed">
                    〒102-0083<br />東京都千代田区麹町2-2-22ACN半蔵門ビル10階
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="border-t border-white/10 pt-8 text-center">
            <p className="text-white/40 text-xs">
              &copy; 2026 株式会社S.A.Security All Rights Reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
